// extracted by mini-css-extract-plugin
module.exports = {"text":"Bullet_text__fENVl","img_wrapper":"Bullet_img_wrapper___3iCo","bullet_container":"Bullet_bullet_container__Cb_Wm"};